module.exports = __webpack_public_path__ + "fb01f774c61dfb4cd7c3a6457bf5d016.svg";